module.exports = __webpack_public_path__ + "img/more.c58ed376.svg";